import { Code } from './Code';
import { Codification } from './Codification';
import { Lock } from './Lock';
export class DoorLock {
    constructor(
        public id?: number,
        public lock?: Lock,
        public durability?: number,
        private _code: Code = new Code([])
    ) {
    }

    public set code(v: Code) {
        if (v.code.length != this.lock.digits) {
            throw Error("Wrong number of digits");
        }
        this._code = v;
    }
    public get code() {
        return this._code;
    }

    public get digits() {
        return this.lock ? this.lock.digits : null;
    }

    public get codification() {
        return this.lock?.codification || new Codification();
    }

    public static fromData(data: any) {
        if (!data) return;
        let o = new DoorLock(
            data.id,
            Lock.fromData(data.lock),
            data.durability,
            Code.fromData(data._code)
        );
        return o;
    }
}